// This logic is used to reload the page when the company has changed in a different window
// For users with salonizedAdmin, this will show the "become" page
// To do this, we save the company id in local storage and reload the page if it has changed, but only if the current window or tab is not active
// To check if the current window or tab is active, we use a combination of visibilitychange and focus events

import {
  useDocumentVisibility,
  useStorage,
  useWindowFocus,
} from '@vueuse/core';
import { onBeforeUnmount } from 'vue';
import { useCompanyStore } from '@/stores/company';

export const useAutoReload = () => {
  const visibility = useDocumentVisibility();
  const isHidden = computed(() => visibility.value !== 'visible'); // The tab is hidden, the user is in another tab in the same window
  const isFocused = useWindowFocus(); // The window is focused, we need to check this in case there are multiple windows open
  const isActive = computed(() => !isHidden.value && isFocused.value);

  const { company } = useCompanyStore();
  const storageCompanyId = useStorage<string | null>('company_id', null);

  watch(
    () => company.id,
    (newCompanyId) => {
      if (newCompanyId) {
        storageCompanyId.value = String(newCompanyId);
      }
    },
    { immediate: true },
  );

  watch(storageCompanyId, (newCompanyId, oldCompanyId) => {
    if (
      !isActive.value &&
      newCompanyId &&
      oldCompanyId &&
      Number.parseInt(newCompanyId) !== Number.parseInt(oldCompanyId)
    ) {
      location.reload();
    }
  });

  onBeforeUnmount(() => {
    storageCompanyId.value = null;
  });
};
